module.exports = {
  'AstralSituationRecord.mgmtTitle': 'Event Management',
  'AstralSituationRecord.new': 'New',
  'AstralSituationRecord.modify': 'Modify',
  'AstralSituationRecord.clone': 'Clone',
  'AstralSituationRecord.close': 'Close',
  'AstralSituationRecord.newEvent': 'New event',
  'AstralSituationRecord.duplicateEvent': 'Duplicate event',
  'AstralSituationRecord.eventMgmt': 'Event management',
  'AstralSituationRecord.management': 'Management',
  'AstralSituationRecord.search': 'Search',
  'AstralSituationRecord.filter': 'Search filters',
  'AstralSituationRecord.event': 'Event',
  'AstralSituationRecord.events': 'Events',
  'AstralSituationRecord.title': 'Title',
  'AstralSituationRecord.description': 'Description',
  'AstralSituationRecord.type': 'Type',
  'AstralSituationRecord.eventType': 'Event type',
  'AstralSituationRecord.list': 'List',
  'AstralSituationRecord.save': 'Save',
  'AstralSituationRecord.cancel': 'Cancel',
  'AstralSituationRecord.delete': 'Delete',
  'AstralSituationRecord.error': 'ERROR',
  'AstralSituationRecord.noResultFound': 'No result found',
  'AstralSituationRecord.saveSuccess': 'Saved successfully',
  'AstralSituationRecord.deleteSuccess': 'Deleted successfully',
  'AstralSituationRecord.id': 'Id',
  'AstralSituationRecord.severity': 'Severity',
  'AstralSituationRecord.version': 'Version',
  'AstralSituationRecord.capacityRemainig': 'Remaining capacity',
  'AstralSituationRecord.numberOfLanesRestricted': 'Number of lanes restricted',
  'AstralSituationRecord.numberOfOperationalLanes':
    'Number of operational lanes',
  'AstralSituationRecord.originalNumberOfLanes': 'Original number of lanes',
  'AstralSituationRecord.residualRoadWidth': 'Residual road width',
  'AstralSituationRecord.validityStatus': 'Validity',
  'AstralSituationRecord.probabilityOfOccurrence': 'Probability',
  'AstralSituationRecord.confidentiality': 'Confidentiality',
  'AstralSituationRecord.region': 'Region',
  'AstralSituationRecord.province': 'Province',
  'AstralSituationRecord.selectOneOrMoreKeywordsHolding':
    'Keywords (select one or more keywords by holding down the CTRL/CMD key)',
  'AstralSituationRecord.cause': 'Cause',
  'AstralSituationRecord.source': 'Source',
  'AstralSituationRecord.sources': 'Sources',
  'AstralSituationRecord.from': 'From',
  'AstralSituationRecord.to': 'To',
  'AstralSituationRecord.validityPeriods': 'Validity periods',
  'AstralSituationRecord.validityPeriod': 'Validity period',
  'AstralSituationRecord.newValidityPeriod': 'New validity period',
  'AstralSituationRecord.comments': 'Comments',
  'AstralSituationRecord.comment': 'Comment',
  'AstralSituationRecord.operatorActionOrigin': 'Operator action origin',
  'AstralSituationRecord.operatorActionStatus': 'Operator action status',
  'AstralSituationRecord.mobilityType': 'Mobility type',
  'AstralSituationRecord.maintenanceVehicleActions':
    'Maintenance vehicle actions',
  'AstralSituationRecord.maintenanceVehicleAction':
    'Maintenance vehicle action',
  'AstralSituationRecord.equipmentOrSystemFaultType':
    'Equipment or system fault type',
  'AstralSituationRecord.faultyEquipmentOrSystemType':
    'Equipment or system type',
  'AstralSituationRecord.abnormalTrafficType': 'Abnormal traffic type',
  'AstralSituationRecord.queueLength': 'Queue length',
  'AstralSituationRecord.trafficFlowCharacteristics':
    'Traffic flow characteristics',
  'AstralSituationRecord.trafficTrendType': 'Traffic trend type',
  'AstralSituationRecord.obstructionType': 'Obstruction type',
  'AstralSituationRecord.environmentalObstructionType':
    'environmental obstruction type',
  'AstralSituationRecord.infrastructureDamageType':
    'Infrastructure damage type',
  'AstralSituationRecord.animalPresenceType': 'Animal presence type',
  'AstralSituationRecord.vehicleObstructionType': 'Vehicle obstruction type',
  'AstralSituationRecord.authorityOperationType': 'Authority operation type',
  'AstralSituationRecord.disturbanceActivityType': 'Disturbance activity type',
  'AstralSituationRecord.nonWeatherRelatedRoadConditionType': 'Condition type',
  'AstralSituationRecord.weatherRelatedRoadConditionType': 'Condition type',
  'AstralSituationRecord.poorEnvironmentType': 'Condition type',
  'AstralSituationRecord.constructionWorkType': 'Construction work type',
  'AstralSituationRecord.roadMaintenanceType': 'Road maintenance type',
  'AstralSituationRecord.generalNetworkManagementType':
    'General network managemen type',
  'AstralSituationRecord.speedManagementType': 'Speed management type',
  'AstralSituationRecord.temporarySpeedLimit': 'Temporary speed limit',
  'AstralSituationRecord.winterEquipmentManagementType':
    'Winter equipment management type',
  'AstralSituationRecord.generalInstructionToRoadUsersType':
    'General instruction to road users type',
  'AstralSituationRecord.roadOrCarriagewayOrLaneManagementType':
    'Road or carriageway or lane management type',
  'AstralSituationRecord.roadsideServiceDisruptionType':
    'Roadside service disruption type',
  'AstralSituationRecord.roadOperatorServiceDisruptionType':
    'Road operator service disruption type',
  'AstralSituationRecord.accidentType': 'Accident type',
  'AstralSituationRecord.vehiclesInvolved': 'Vehicles Involved',
  'AstralSituationRecord.listOfCauses': 'List of causes',
  'AstralSituationRecord.prevEvent': 'Previous event',
  'AstralSituationRecord.NotNull': 'The field cannot be null',
  'AstralSituationRecord.NotEmpty': 'The field cannot be empty',
  'AstralSituationRecord.Min': 'The value is lower than the allowed minimum',
  'AstralSituationRecord.Max': 'The value is greather than the allowed maximum',
  'AstralSituationRecord.SituationRecordValidityPeriodValid':
    'Not valid list: it cannot be empty and only the last period can have an empty end date',
  'AstralSituationRecord.ValidityPeriodDatesValid':
    'Validity periodo non valid',
  'AstralSituationRecord.creationDate': 'Creation date',
  'AstralSituationRecord.totItems': 'Total items',
  'AstralSituationRecord.pagination': 'Pagination',
  'AstralSituationRecord.itemsPerPage': 'Items per page',
  'AstralSituationRecord.all': 'All',
  'AstralSituationRecord.csvDownload': 'CSV download',
  'AstralSituationRecord.eventSearch': 'Event search',
  'AstralSituationRecord.notValidParameter': 'Not valid parameter',
  'AstralSituationRecord.of': 'of',
  'AstralSituationRecord.dashboard': 'Dashboard',
  'AstralSituationRecord.map': 'Map',
  'AstralSituationRecord.select': 'Please select',
  'AstralSituationRecord.ok': 'Ok',
  'AstralSituationRecord.attention': 'Attention',
  'AstralSituationRecord.deleteItemQuest': 'Delete the current item?',
  'AstralSituationRecord.back': 'Back',
  'AstralSituationRecord.sourceList': 'Source list',
  'AstralSituationRecord.date': 'Date',
  'AstralSituationRecord.reliable': 'Reliable',
  'AstralSituationRecord.reset': 'Reset',
  'AstralSituationRecord.newSource': 'New source',
  'AstralSituationRecord.sourceMgmt': 'Source management',
  'AstralSituationRecord.location': 'Location',
  'AstralSituationRecord.actionOrigin': 'Action origin',
  'AstralSituationRecord.animalAlive': 'Alive animal',
  'AstralSituationRecord.Error.sourceDelExistingSituationRecord':
    'The selected source can not be deleted. There are connected events in the database',
  'AstralSituationRecord.Error.situationRecordDelExistingSituationRecord':
    'The selected event can not be deleted. There are connected events in the database',
  'AstralSituationRecord.notSavedChanges': 'Save changes?',
  'AstralSituationRecord.yes': 'Yes',
  'AstralSituationRecord.no': 'No',
  'AstralSituationRecord.complianceOption': 'Compliance oOption',
  'AstralSituationRecord.automaticallyInitiated': 'Automatically initiated',
  'AstralSituationRecord.error.reloadPage':
    'Server error. Please, try again leater',
  'AstralSituationRecord.error.expiredSession': 'Expired session',
  'AstralSituationRecord.error.multipleObjOnMap':
    'Multiple items have been created on the map. Select points or a route',
  'AstralSituationRecord.error.noObjOnMap':
    'Create a map location (points or route)',
  'AstralSituationRecord.selectedFilters': 'Selected filters',
  'AstralSituationRecord.cotral': 'Regional bus stop COTRAL',
  'AstralSituationRecord.atac': 'Bus stop ATAC',
  'AstralSituationRecord.ferrovie': 'State railway stations',
  'AstralSituationRecord.aeroporti1':
    'National or international flights airports',
  'AstralSituationRecord.aeroporti2': 'Other airports',
  'AstralSituationRecord.porti1': 'National and international routes ports',
  'AstralSituationRecord.porti2': 'Regional routes ports',
  'AstralSituationRecord.porti3': 'Other ports',
  'AstralSituationRecord.traffico': 'Traffic',
  'AstralSituationRecord.transit': 'Transit',
  'AstralSituationRecord.meteo': 'Meteo',
  'AstralSituationRecord.telecamereAstraL': 'AstraL cameras',
  'AstralSituationRecord.telecamereAutostrade':
    "Autostrade per l'Italia cameras",
  'AstralSituationRecord.mapMenuButton': 'Map layers menu ',
  'AstralSituationRecord.publicSiteEvidence':
    'In evidence on the public web site',
  'AstralSituationRecord.publicSiteEvidence2': 'Evid.',
  'AstralSituationRecord.title': 'Title',
  'AstralSituationRecord.isSystem': 'System',
  'AstralSituationRecord.titleDescription': 'Title/Descriptioin',
  'AstralSituationRecord.data': 'Data',
  'AstralSituationRecord.otherInfo': 'Other information',
  'AstralSituationRecord.attachments': 'Attachments',
  'AstralSituationRecord.selectFile': 'Select file',
  'AstralSituationRecord.newAttachment': 'New attachment',
  'AstralSituationRecord.delAttachment': 'Cancel attachment',
  'AstralSituationRecord.downloadAttachment': 'Download attachment',
  'AstralSituationRecord.dragFile': 'Drag file',
  'AstralSituationRecord.newAttachmentError': 'Errore saving attachment ',
  'AstralSituationRecord.delAttachmentError': 'Errore deleting attachment ',
  'AstralSituationRecord.validationErrors': 'Data validation errors',
  'AstralSituationRecord.saveAsTemplate': 'Save as template',
  'AstralSituationRecord.templateName': 'Ttemplate name',
  'AstralSituationRecord.notValidTemplateName': 'Not valid template name',
  'AstralSituationRecord.templates': 'Templates',
  'AstralSituationRecord.keywords': 'Keywords',
  'AstralSituationRecord.channels': 'Channels',
  'AstralSituationRecord.channel': 'Channel',
  'AstralSituationRecord.channel.is-public': 'Visible',
  'AstralSituationRecord.channel.actions': 'Actions',
  'AstralSituationRecord.publicSite': 'Public site',
  'AstralSituationRecord.carousel': 'Carousel',
  'AstralSituationRecord.newsBullettin': 'Promotional Medias',
  'AstralSituationRecord.templateList': 'Template list',
  'AstralSituationRecord.createFromTemplate': 'Create event from template',
  'AstralSituationRecord.name': 'Name',
  'AstralSituationRecord.templateMgmt': 'Template management',
  'AstralSituationRecord.saveEvent': 'Save event',
  'AstralSituationRecord.templateSearch': 'Template search',
  'AstralSituationRecord.valid': 'Valid',
  'AstralSituationRecord.public': 'Publ.',
  'AstralSituationRecord.createdBy2': 'Creat. by',
  'AstralSituationRecord.updatedBy2': 'Upd. by',
  'AstralSituationRecord.updatedDate2': 'Upd. date',
  'AstralSituationRecord.creationDate2': 'Creat. date',
  'AstralSituationRecord.createdBy': 'Created by',
  'AstralSituationRecord.updatedBy': 'Updated by',
  'AstralSituationRecord.updatedDate': 'Update date',
  'AstralSituationRecord.isValid': 'Only valid events',
  'AstralSituationRecord.createdUpdateDate': 'Creat./upd. date',
  'AstralSituationRecord.createdUpdateBy': 'Created/updated by',
  'AstralSituationRecord.update': 'Update',
  'AstralSituationRecord.broadcast': 'Broadcast',
  'AstralSituationRecord.future': 'Future',
  'AstralSituationRecord.createdUpdateDateExt': 'Created/updated date',
  'AstralSituationRecord.publicExt': 'Pubblic event',
  'AstralSituationRecord.validExt': 'Valid event',
  'AstralSituationRecord.futureExt': 'Future event',
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/languages/en.js
// module id = 294
// module chunks = 0